import React from 'react';
import { showETA,showEDTA} from '../Helper';
import * as constants from '../../../constants';
import WithdrawnReasonPopover from '../Popover/index';
import { useDispatch } from 'react-redux';
import { downloadAttachmentRequest } from '../../action';

const CaseDetails = (props) => {
     const dispatch = useDispatch();

    const handleAttachmentClick = () => {
        dispatch(downloadAttachmentRequest(props.metadata.caseAttachmentFileName));
    };
    return (
        <table className="table table-bordered border-bottom-0 case-about-table">
            <tbody>
                <tr>
                    <th className="header-blue" width="30%">Case Id</th>
                    <td title={props.metadata.caseId} className="text-truncate"> {props.metadata.caseId} </td>
                </tr>
                <tr>
                    <th width="15%" className="header-blue">Case Name</th>
                    <td title={props.metadata.counterpartyName} className="text-truncate"> {props.metadata.counterpartyName} </td>
                </tr>
                <tr>
                    <th width="15%" className="header-blue">Client Name</th>
                    <td title={props.metadata.corporateName} className="text-truncate"> {props.metadata.corporateName} </td>
                </tr>
                <tr>
                    <th width="15%" className="header-blue">Product Name</th>
                    <td title={props.metadata.productName} className="text-truncate"> {props.metadata.productName}  </td>
                </tr>
                <tr>
                    <th width="15%" className="header-blue">Due date</th>
                    <td> {showETA(props.metadata.dueDate)} </td>
                </tr>
                <tr>
                    <th width="15%" className="header-blue">Status</th>
                    <td> {props.metadata.status}{props.viewPublishedReport}
                        {props.metadata.status === constants.WITHDRAWN ? (
                            <WithdrawnReasonPopover withdrawnReason={props.metadata.withdrawalReason} />
                        ) : props.metadata.status === constants.ONHOLD ? (
                            <WithdrawnReasonPopover withdrawnReason={props.metadata.onHoldReason} />
                        ) : ''}
                    </td>
                </tr>
                <tr>
                    <th width="15%" className="header-blue">Mis OrderId</th>
                    <td> {props.metadata.misOrderId} </td>
                </tr>
                <tr>
                    <th width="15%" className="header-blue">Allocated to</th>
                    <td title={props.metadata.assignedTo} className="text-truncate"> {props.metadata.assignedTo} </td>
                </tr>
                <tr>
                    <th width="15%" className="header-blue">Enquiry Reference Number</th>
                    <td title={props.metadata.enquiryReferenceNumber} className="text-truncate"> {props.metadata.enquiryReferenceNumber} </td>
                </tr>
                
                <tr>
                    <th width="15%" className="header-blue">Buyer Code</th>
                    <td title={props.metadata.buyerCode} className="text-truncate"> {props.metadata.buyerCode} </td>
                </tr>
                <tr>
                    <th width="15%" className="header-blue">Local Party Name</th>
                    <td title={props.metadata.indianPartyName} className="text-truncate"> {props.metadata.indianPartyName} </td>
                </tr>
                <tr>
                    <th width="15%" className="header-blue">Contact Details</th>
                    <td title={props.metadata.counterpartyContactDetails} className="text-truncate"> {props.metadata.counterpartyContactDetails} </td>
                </tr>
                <tr>
                    <th width="15%" className="header-blue">Website</th>
                    <td title={props.metadata.counterpartyWebsite} className="text-truncate"> {props.metadata.counterpartyWebsite} </td>
                </tr>
                <tr>
                    <th width="15%" className="header-blue">Email</th>
                    <td title={props.metadata.counterpartyEmail} className="text-truncate"> {props.metadata.counterpartyEmail} </td>
                </tr>
                
                <tr>
                    <th width="15%" className="header-blue">Other Enquiry Details</th>
                    <td title={props.metadata.otherEnquiryDetails} className="text-truncate"> {props.metadata.otherEnquiryDetails} </td>
                </tr>
                <tr>
                    <th width="15%" className="header-blue">Requested By</th>
                    <td title={props.metadata.createdByName} className="text-truncate"> {props.metadata.createdByName} </td>
                </tr>
                <tr>
                    <th width="15%" className="header-blue">Requested On</th>
                    <td> {showEDTA(props.metadata.createdAt)} </td>
                </tr>
                <tr>
                    <th width="15%" className="header-blue">Last Updated By</th>
                    <td title={props.metadata.updatedByName} className="text-truncate"> {props.metadata.updatedByName} </td>
                </tr>
                <tr>
                    <th width="15%" className="header-blue">Last Updated On</th>
                    <td> {showEDTA(props.metadata.updatedAt)} </td>
                </tr>
                <tr>
                    <th width="15%" className="header-blue">Emails</th>
                    <td title={props.metadata.caseEmails} className="text-truncate"> {props.metadata.caseEmails} </td>
                </tr>
                
                {props.metadata.caseAttachmentFileName && (
                    <tr>
                        <th width="15%" className="header-blue">Case Attachment</th>
                        <td title={props.metadata.caseAttachmentFileName}  style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                    onClick={handleAttachmentClick} className="text-truncate">
                            {props.metadata.caseAttachmentFileName}
                        </td>
                    </tr>
                )}
            </tbody>
            {/* <thead className="header-blue">
                <tr>
                    <th width="15%">Case ID</th>
                    <th width="15%">Case Name</th>
                    <th width="15%">Client Name</th>
                    <th width="15%">Created on</th>
                    <th width="10%">Due date</th>
                    <th width="15%">Status</th>
                    <th width="15%">Allocated to</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td title={props.metadata.caseId} className="text-truncate"> {props.metadata.caseId} </td>
                    <td title={props.metadata.counterpartyName} className="text-truncate"> {props.metadata.counterpartyName} </td>
                    <td title={props.metadata.corporateName} className="text-truncate"> {props.metadata.corporateName} </td>
                    <td> {showETA(props.metadata.createdAt)} </td>
                    <td> {showETA(props.metadata.dueDate)} </td>
                    <td> {props.metadata.status}{props.viewPublishedReport}
                        {(props.metadata.status === constants.WITHDRAWN) ? < WithdrawnReasonPopover withdrawnReason={props.metadata.withdrawalReason} /> : ''}
                    </td>
                    <td title={props.metadata.assignedTo} className="text-truncate"> {props.metadata.assignedTo} </td>
                </tr>
            </tbody> */}
        </table>
    )
}

export default CaseDetails